<template>
  <!-- 团体赛-生成选手手册海报弹窗组件 -->
  <el-dialog
    title="编辑团体赛选手手册海报"
    :visible.sync="posterDialogVisible"
    width="1240px"
    append-to-body
    class="team-poster-manual-dialog"
    top="4vh"
    @close="closePosterDialog"
  >
    <template v-if="posterFormData">
      <div
        class="poster-toolbar poster-toolbar-text"
        v-if="selectedPosterKey && selectedPosterKey !== 'avatar'"
      >
        <span class="toolbar-label">字号：</span>
        <el-input-number
          :value="posterTextStyles[selectedPosterKey].fontSize"
          @input="setPosterStyleField(selectedPosterKey, 'fontSize', $event)"
          :min="12"
          :max="posterTextFontSizeMax"
          :step="1"
          size="small"
          style="width: 100px; vertical-align: middle;"
        ></el-input-number>
        <span class="toolbar-value">px</span>
        <span class="toolbar-label" style="margin-left: 12px;">颜色：</span>
        <input
          type="color"
          :value="posterTextStyles[selectedPosterKey].color"
          @change="onPosterColorChange(selectedPosterKey, $event.target.value)"
          class="poster-color-input"
          title="文字颜色"
        />
        <span class="toolbar-label" style="margin-left: 12px;">字重：</span>
        <el-select
          :value="getPosterBoldStage(selectedPosterKey)"
          @input="setPosterBoldStage(selectedPosterKey, $event)"
          size="mini"
          style="width: 120px;"
        >
          <el-option label="400" value="400"></el-option>
          <el-option label="500" value="500"></el-option>
          <el-option label="600" value="600"></el-option>
          <el-option label="700" value="700"></el-option>
          <el-option label="800" value="800"></el-option>
          <el-option label="900" value="900"></el-option>
        </el-select>
        <span class="toolbar-label" style="margin-left: 12px;">对齐：</span>
        <el-select
          :value="posterTextStyles[selectedPosterKey].textAlign || 'left'"
          @input="setPosterStyleField(selectedPosterKey, 'textAlign', $event)"
          size="mini"
          style="width: 110px;"
        >
          <el-option label="左对齐" value="left"></el-option>
          <el-option label="居中" value="center"></el-option>
          <el-option label="右对齐" value="right"></el-option>
        </el-select>
        <el-button
          size="mini"
          type="info"
          plain
          @click="selectedPosterKey = null"
          style="margin-left: 12px;"
        >取消选中</el-button>
        <div class="poster-edit-content-wrap">
          <span class="toolbar-label">编辑内容（可回车换行）：</span>
          <el-input
            type="textarea"
            :value="posterFormData[selectedPosterKey]"
            @input="setPosterFormField(selectedPosterKey, $event)"
            :rows="3"
            placeholder="输入内容，回车换行"
            class="poster-content-textarea"
          ></el-input>
        </div>
      </div>
      <div
        class="poster-toolbar"
        v-else-if="selectedPosterKey === 'avatar'"
      >
        <span class="toolbar-label">头像宽度：</span>
        <el-input-number
          :value="posterTextStyles.avatar.width"
          @input="setPosterAvatarSize($event)"
          :min="80"
          :max="260"
          :step="5"
          size="small"
          style="width: 110px; vertical-align: middle;"
        ></el-input-number>
        <span class="toolbar-value">px</span>
        <span class="toolbar-label" style="margin-left: 12px;">缩放：</span>
        <el-input-number
          :value="posterTextStyles.avatar.scale"
          @input="setPosterStyleField('avatar', 'scale', $event)"
          :min="0.5"
          :max="2"
          :step="0.1"
          :precision="1"
          size="small"
          style="width: 100px; vertical-align: middle;"
        ></el-input-number>
        <span class="toolbar-value">(0.5~2倍)</span>
        <el-button
          size="mini"
          type="info"
          plain
          @click="selectedPosterKey = null"
          style="margin-left: 12px;"
        >取消选中</el-button>
      </div>
      <div
        class="poster-wrap"
        ref="posterWrapRef"
      >
        <div
          class="poster-viewport"
          :style="posterViewportStyle"
        >
          <div
            ref="posterScaleInner"
            class="poster-scale-inner"
            :style="posterScaleInnerStyle"
          >
            <div
              id="teamPosterExportBox"
              class="poster-canvas-box"
              :style="{ width: posterWidth + 'px', height: posterHeight + 'px' }"
            >
              <img
                class="poster-bg"
                src="https://cdn.spbcn.org/spbcnappneed/itsouser-info-back02.png"
                alt=""
                crossorigin="anonymous"
              />
              <!-- 左侧：选手头像 -->
              <div
                class="poster-item poster-avatar"
                :style="getPosterItemStyle('avatar')"
                @mousedown.prevent="startDrag($event, 'avatar')"
                @click.stop="selectedPosterKey = 'avatar'"
              >
                <div class="avatar-img" :style="getAvatarImageStyle()"></div>
              </div>
              <!-- 橙色区域：姓名 -->
              <div
                class="poster-item poster-text"
                :class="{ selected: selectedPosterKey === 'userName' }"
                :style="getPosterItemStyle('userName')"
                @mousedown.prevent="startDrag($event, 'userName')"
                @click.stop="selectedPosterKey = 'userName'"
              >{{ posterFormData.userName }}</div>
              <!-- 橙色区域：SPBCN 赛区 -->
              <div
                class="poster-item poster-text"
                :class="{ selected: selectedPosterKey === 'districtName' }"
                :style="getPosterItemStyle('districtName')"
                @mousedown.prevent="startDrag($event, 'districtName')"
                @click.stop="selectedPosterKey = 'districtName'"
              >{{ posterFormData.districtName }}</div>
              <!-- 橙色区域：年龄年级 -->
              <div
                class="poster-item poster-text"
                :class="{ selected: selectedPosterKey === 'ageGrade' }"
                :style="getPosterItemStyle('ageGrade')"
                @mousedown.prevent="startDrag($event, 'ageGrade')"
                @click.stop="selectedPosterKey = 'ageGrade'"
              >{{ posterFormData.ageGrade }}</div>
              <!-- 左列-对参赛其他选手的寄语 -->
              <div
                class="poster-item poster-text poster-content-text"
                :class="{ selected: selectedPosterKey === 'sendWord' }"
                :style="getPosterItemStyle('sendWord')"
                @mousedown.prevent="startDrag($event, 'sendWord')"
                @click.stop="selectedPosterKey = 'sendWord'"
              >{{ posterFormData.sendWord }}</div>
              <!-- 左列-全国级比赛对于本人的意义 -->
              <div
                class="poster-item poster-text poster-content-text"
                :class="{ selected: selectedPosterKey === 'significance' }"
                :style="getPosterItemStyle('significance')"
                @mousedown.prevent="startDrag($event, 'significance')"
                @click.stop="selectedPosterKey = 'significance'"
              >{{ posterFormData.significance }}</div>
              <!-- 左列-如果你赢得了奖金，会做什么 -->
              <div
                class="poster-item poster-text poster-content-text"
                :class="{ selected: selectedPosterKey === 'purposeBonus' }"
                :style="getPosterItemStyle('purposeBonus')"
                @mousedown.prevent="startDrag($event, 'purposeBonus')"
                @click.stop="selectedPosterKey = 'purposeBonus'"
              >{{ posterFormData.purposeBonus }}</div>
              <!-- 右列-目前对自己最难的单词 -->
              <div
                class="poster-item poster-text poster-content-text"
                :class="{ selected: selectedPosterKey === 'motto' }"
                :style="getPosterItemStyle('motto')"
                @mousedown.prevent="startDrag($event, 'motto')"
                @click.stop="selectedPosterKey = 'motto'"
              >{{ posterFormData.motto }}</div>
              <!-- 右列-最喜欢的书籍 -->
              <div
                class="poster-item poster-text poster-content-text"
                :class="{ selected: selectedPosterKey === 'Favoritebooks' }"
                :style="getPosterItemStyle('Favoritebooks')"
                @mousedown.prevent="startDrag($event, 'Favoritebooks')"
                @click.stop="selectedPosterKey = 'Favoritebooks'"
              >{{ posterFormData.Favoritebooks }}</div>
              <!-- 右列-兴趣爱好 -->
              <div
                class="poster-item poster-text poster-content-text"
                :class="{ selected: selectedPosterKey === 'hobbies' }"
                :style="getPosterItemStyle('hobbies')"
                @mousedown.prevent="startDrag($event, 'hobbies')"
                @click.stop="selectedPosterKey = 'hobbies'"
              >{{ posterFormData.hobbies }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
      <el-button
        @click="undoPoster"
        :disabled="!posterUndoStack.length"
        title="撤销上一步操作"
      >撤 销</el-button>
      <el-button @click="posterDialogVisible = false">取 消</el-button>
      <el-button
        plain
        @click="resetPosterToInitial"
        title="恢复为准确坐标、字号、色号、粗细"
      >恢复为初始状态</el-button>
      <el-button
        plain
        @click="loadSavedPosterDefaults"
        title="应用之前保存的布局"
      >使用已保存的默认位置</el-button>
      <el-button
        type="primary"
        plain
        @click="savePosterStylesAsDefault"
      >保存为默认位置</el-button>
      <el-button
        type="primary"
        @click="downloadPosterImage"
      >保存并下载海报</el-button>
    </span>
  </el-dialog>
</template>

<script>
import html2canvas from 'html2canvas'

const STORAGE_KEY = 'teamPosterManualDefaultStyles'

export default {
  name: 'TeamCompetitorManual',
  data () {
    return {
      userInfoData: {},
      posterDialogVisible: false,
      posterFormData: null,
      posterWidth: 1100,
      posterHeight: 680,
      posterTextStyles: {},
      selectedPosterKey: null,
      posterDragState: null,
      posterUndoStack: [],
      posterUndoMaxSize: 30,
      posterRestoringUndo: false,
      posterPreviewScale: 0.78,
      isExportingPoster: false
    }
  },
  computed: {
    posterViewportStyle () {
      const w = this.posterWidth
      const h = this.posterHeight
      const s = this.posterPreviewScale
      if (this.isExportingPoster) {
        return { width: w + 'px', height: h + 'px', overflow: 'visible' }
      }
      return {
        width: Math.round(w * s) + 'px',
        height: Math.round(h * s) + 'px',
        overflow: 'hidden'
      }
    },
    posterScaleInnerStyle () {
      const w = this.posterWidth
      const h = this.posterHeight
      const s = this.posterPreviewScale
      const base = {
        width: w + 'px',
        height: h + 'px',
        transformOrigin: 'top left'
      }
      if (this.isExportingPoster) return { ...base, transform: 'none' }
      return { ...base, transform: `scale(${s})` }
    },
    posterTextFontSizeMax () {
      return 120
    }
  },
  methods: {
    // 对外暴露：打开海报编辑弹窗
    open (row) {
      if (row) {
        const details = row.sysUserDetails
        const requiredDetailKeys = [
          'age',
          'message',
          'significance',
          'winningAction',
          'difficultyWord',
          'hobby',
          'likeBook'
        ]
        const isMissing = !details || requiredDetailKeys.some((k) => {
          const v = details[k]
          return v == null || (typeof v === 'string' && v.trim() === '')
        })
        if (isMissing) {
          this.$message.warning('该选手暂未完善详细信息！')
          return
        }
      }
      const data = row
        ? {
          avatar: row.oneInchPhoto || row.headImgUrl || this.userInfoData.oneInchPhoto,
          userName: row.userName || row.studentName || this.userInfoData.userName,
          districtName: row.districtName || this.userInfoData.districtName || '',
          grade: row.grade || this.userInfoData.grade,
          schoolName: row.schoolName || this.userInfoData.schoolName,
          age: row.sysUserDetails && row.sysUserDetails.age != null ? row.sysUserDetails.age : this.userInfoData.age,
          NationalNum: row.nationalnum || row.nationalNum || this.userInfoData.NationalNum,
          sendWord: (row.sysUserDetails && row.sysUserDetails.message) || this.userInfoData.message,
          significance: (row.sysUserDetails && row.sysUserDetails.significance) || this.userInfoData.significance,
          purposeBonus: (row.sysUserDetails && row.sysUserDetails.winningAction) || this.userInfoData.winningAction,
          motto: (row.sysUserDetails && row.sysUserDetails.difficultyWord) || this.userInfoData.difficultyWord,
          hobbies: (row.sysUserDetails && row.sysUserDetails.hobby) || this.userInfoData.hobby,
          Favoritebooks: (row.sysUserDetails && row.sysUserDetails.likeBook) || this.userInfoData.likeBook
        }
        : { ...this.userInfoData }
      data.ageGrade = data.ageGrade || ((data.age != null ? data.age : '') + '岁 ' + (data.grade != null ? (data.grade + '年级') : ''))
      this.posterFormData = data
      this.posterTextStyles = this.getDefaultPosterTextStyles()
      this.selectedPosterKey = null
      this.posterUndoStack = []
      this.posterDialogVisible = true
    },
    // 初始状态：根据背景图 itsouser-info-back.png 调整好的默认布局
    getDefaultPosterTextStyles () {
      return {
        avatar: { left: 92, top: 82, fontSize: 16, width: 200, height: 269, scale: 1 },
        userName: { left: 468, top: 86, fontSize: 42, color: '#ffffff', bold: true, boldStage: '700', textAlign: 'center' },
        districtName: { left: 693, top: 92, fontSize: 30, color: '#ffffff', bold: true, boldStage: '600', textAlign: 'center' },
        ageGrade: { left: 934, top: 95, fontSize: 24, color: '#ffffff', bold: false, boldStage: '400', textAlign: 'center' },
        sendWord: { left: 364, top: 247, fontSize: 21, color: '#333333', bold: false, boldStage: '400', textAlign: 'left' },
        significance: { left: 364, top: 380, fontSize: 21, color: '#333333', bold: false, boldStage: '400', textAlign: 'left' },
        purposeBonus: { left: 364, top: 523, fontSize: 21, color: '#333333', bold: false, boldStage: '400', textAlign: 'left' },
        motto: { left: 773, top: 247, fontSize: 21, color: '#333333', bold: false, boldStage: '400', textAlign: 'left' },
        Favoritebooks: { left: 773, top: 380, fontSize: 21, color: '#333333', bold: false, boldStage: '400', textAlign: 'left' },
        hobbies: { left: 773, top: 523, fontSize: 21, color: '#333333', bold: false, boldStage: '400', textAlign: 'left' }
      }
    },
    resetPosterToInitial () {
      this.pushPosterUndoSnapshot()
      this.posterTextStyles = this.getDefaultPosterTextStyles()
      this.$message.success('已恢复为初始布局')
    },
    loadSavedPosterDefaults () {
      try {
        const saved = window.localStorage.getItem(STORAGE_KEY)
        if (!saved) {
          this.$message.info('暂无已保存的默认位置')
          return
        }
        const parsed = JSON.parse(saved)
        const builtin = this.getDefaultPosterTextStyles()
        const keys = Object.keys(builtin)
        if (!keys.every(k => parsed[k] && typeof parsed[k].left === 'number' && typeof parsed[k].top === 'number')) {
          this.$message.warning('已保存的数据不完整，请重新保存为默认位置')
          return
        }
        this.pushPosterUndoSnapshot()
        this.posterTextStyles = keys.reduce((acc, k) => {
          acc[k] = { ...builtin[k], ...parsed[k] }
          return acc
        }, {})
        this.$message.success('已应用已保存的默认位置')
      } catch (e) {
        this.$message.error('加载失败：' + (e && e.message))
      }
    },
    pushPosterUndoSnapshot () {
      if (this.posterRestoringUndo || !this.posterFormData) return
      const snap = {
        styles: JSON.parse(JSON.stringify(this.posterTextStyles)),
        formData: JSON.parse(JSON.stringify(this.posterFormData))
      }
      this.posterUndoStack.push(snap)
      if (this.posterUndoStack.length > this.posterUndoMaxSize) this.posterUndoStack.shift()
    },
    undoPoster () {
      if (!this.posterUndoStack.length) return
      const snap = this.posterUndoStack.pop()
      this.posterRestoringUndo = true
      this.posterTextStyles = snap.styles
      this.posterFormData = snap.formData
      this.$nextTick(() => { this.posterRestoringUndo = false })
    },
    setPosterStyleField (key, field, value) {
      this.pushPosterUndoSnapshot()
      if (this.posterTextStyles[key]) this.$set(this.posterTextStyles[key], field, value)
    },
    getPosterBoldStage (key) {
      const s = key && this.posterTextStyles[key]
      if (!s) return '400'
      if (s.boldStage) {
        if (s.boldStage === 'heavy') return '900'
        if (s.boldStage === 'bold') return '700'
        if (s.boldStage === 'normal') return '400'
        const n = Number(s.boldStage)
        if ([400, 500, 600, 700, 800, 900].includes(n)) return String(n)
      }
      if (s.bold) return key === 'userName' ? '900' : '700'
      return '400'
    },
    setPosterBoldStage (key, stage) {
      if (!key || !this.posterTextStyles[key]) return
      this.pushPosterUndoSnapshot()
      const n = Number(stage)
      const weight = [400, 500, 600, 700, 800, 900].includes(n) ? n : 400
      this.$set(this.posterTextStyles[key], 'boldStage', String(weight))
      this.$set(this.posterTextStyles[key], 'bold', weight >= 700)
    },
    setPosterFormField (field, value) {
      this.pushPosterUndoSnapshot()
      this.$set(this.posterFormData, field, value)
    },
    setPosterAvatarSize (width) {
      const avatar = this.posterTextStyles.avatar
      if (avatar) {
        const nextWidth = Number(width)
        const prevWidth = Number(avatar.width) || 1
        const prevHeight = Number(avatar.height) || 1
        if (nextWidth === prevWidth) return
        this.pushPosterUndoSnapshot()
        const ratio = prevHeight / prevWidth
        const nextHeight = Math.max(1, Math.round(nextWidth * ratio))
        this.$set(avatar, 'width', nextWidth)
        this.$set(avatar, 'height', nextHeight)
      }
    },
    savePosterStylesAsDefault () {
      try {
        const toSave = JSON.stringify(this.posterTextStyles)
        window.localStorage.setItem(STORAGE_KEY, toSave)
        this.$message.success('已保存为默认位置，可点击「使用已保存的默认位置」应用')
        console.log(localStorage.getItem('teamPosterManualDefaultStyles'))
      } catch (e) {
        this.$message.error('保存失败：' + (e && e.message))
      }
    },
    getPosterItemStyle (key) {
      const s = this.posterTextStyles[key]
      if (!s) return {}
      const fontSizePx = Number(s.fontSize) || 14
      const style = {
        left: s.left + 'px',
        top: s.top + 'px',
        fontSize: fontSizePx + 'px'
      }
      if (key === 'userName' || key === 'districtName' || key === 'ageGrade') {
        style.transform = 'translateX(-50%)'
        style.textAlign = s.textAlign || 'center'
        // 锁定行高为 fontSize，保证三者以同一视觉中心 Y 对齐
        style.lineHeight = '1'
        if (key === 'ageGrade') {
          // 年龄年级保持单行不换行
          style.whiteSpace = 'nowrap'
        } else {
          // 姓名 / 赛区 支持回车换行及超出自动换行
          style.whiteSpace = 'pre-line'
          style.wordBreak = 'break-word'
          style.maxWidth = key === 'userName' ? '420px' : '320px'
        }
        if (key === 'userName') style.letterSpacing = '2px'
      }
      if (
        key === 'sendWord' ||
        key === 'significance' ||
        key === 'purposeBonus' ||
        key === 'motto' ||
        key === 'Favoritebooks' ||
        key === 'hobbies'
      ) {
        // 右列三项宽度较窄（减少 50px）
        const isRightColumn = (key === 'motto' || key === 'Favoritebooks' || key === 'hobbies')
        const widthPx = isRightColumn ? '260px' : '320px'
        style.maxWidth = widthPx
        style.width = widthPx
        style.boxSizing = 'border-box'
        style.lineHeight = '1.45'
        style.wordBreak = 'break-word'
        style.whiteSpace = 'pre-line'
      }
      if (key !== 'avatar') {
        style.color = s.color || '#333333'
        if (s.textAlign) style.textAlign = s.textAlign
        style.fontWeight = this.getPosterBoldStage(key)
      }
      if (key === 'avatar') {
        const scale = s.scale != null ? Number(s.scale) : 1
        if (s.width) style.width = Math.max(1, Math.round(Number(s.width) * scale)) + 'px'
        if (s.height) style.height = Math.max(1, Math.round(Number(s.height) * scale)) + 'px'
      } else {
        if (s.width) style.width = s.width + 'px'
        if (s.height) style.height = s.height + 'px'
      }
      return style
    },
    getAvatarImageStyle () {
      const url = (this.posterFormData && this.posterFormData.avatar) || ''
      return {
        backgroundImage: `url('${url}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }
    },
    startDrag (e, key) {
      const s = this.posterTextStyles[key]
      if (!s) return
      const el = e.currentTarget
      if (!el) return
      this.posterDragState = {
        key,
        el,
        startX: e.clientX,
        startY: e.clientY,
        startLeft: s.left,
        startTop: s.top,
        lastLeft: s.left,
        lastTop: s.top
      }
      document.addEventListener('mousemove', this.onPosterDrag)
      document.addEventListener('mouseup', this.onPosterDragEnd)
    },
    onPosterDrag (e) {
      if (!this.posterDragState) return
      const { el, startX, startY, startLeft, startTop } = this.posterDragState
      const dx = e.clientX - startX
      const dy = e.clientY - startY
      const newLeft = Math.max(0, startLeft + dx)
      const newTop = Math.max(0, startTop + dy)
      this.posterDragState.lastLeft = newLeft
      this.posterDragState.lastTop = newTop
      el.style.left = newLeft + 'px'
      el.style.top = newTop + 'px'
    },
    onPosterDragEnd () {
      const state = this.posterDragState
      if (state) {
        const { key, lastLeft, lastTop, startLeft, startTop } = state
        if (key != null && lastLeft != null && lastTop != null) {
          const moved = (lastLeft !== startLeft || lastTop !== startTop)
          if (moved) {
            this.pushPosterUndoSnapshot()
            this.$set(this.posterTextStyles[key], 'left', lastLeft)
            this.$set(this.posterTextStyles[key], 'top', lastTop)
          }
        }
      }
      this.posterDragState = null
      document.removeEventListener('mousemove', this.onPosterDrag)
      document.removeEventListener('mouseup', this.onPosterDragEnd)
    },
    onPosterColorChange (key, value) {
      if (key && this.posterTextStyles[key]) {
        this.pushPosterUndoSnapshot()
        this.$set(this.posterTextStyles[key], 'color', value)
      }
    },
    closePosterDialog () {
      this.selectedPosterKey = null
      this.onPosterDragEnd()
    },
    downloadPosterImage () {
      const box = document.getElementById('teamPosterExportBox')
      if (!box) {
        this.$message.error('未找到海报区域')
        return
      }
      this.$message.info('正在生成图片...')
      this.isExportingPoster = true
      this.$nextTick(() => {
        html2canvas(box, {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          backgroundColor: null,
          logging: false
        }).then(canvas => {
          const url = canvas.toDataURL('image/png', 1)
          const link = document.createElement('a')
          link.href = url
          link.download = `团体赛选手手册_${(this.posterFormData && this.posterFormData.userName) || '海报'}_${Date.now()}.png`
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          this.$message.success('海报已下载')
        }).catch(err => {
          console.error('html2canvas err', err)
          this.$message.error('生成图片失败')
        }).finally(() => {
          this.isExportingPoster = false
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.team-poster-manual-dialog {
  ::v-deep .el-dialog__body {
    padding: 8px 12px 12px;
    max-height: calc(100vh - 130px);
    overflow-y: auto;
    box-sizing: border-box;
  }
  ::v-deep .el-dialog__footer {
    padding: 10px 16px 14px;
  }
  ::v-deep .el-dialog__footer .dialog-footer {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }
  .poster-toolbar {
    margin-bottom: 12px;
    padding: 8px 12px;
    background: #f5f7fa;
    border-radius: 4px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .toolbar-label {
      margin-right: 8px;
      font-size: 14px;
    }
    .toolbar-value {
      margin-left: 8px;
      font-size: 13px;
      color: #606266;
    }
    &.poster-toolbar-text {
      align-items: flex-start;
      .poster-edit-content-wrap {
        width: 100%;
        margin-top: 10px;
        padding-top: 8px;
        border-top: 1px dashed #dcdfe6;
        .toolbar-label {
          display: block;
          margin-bottom: 6px;
        }
      }
      .poster-content-textarea {
        width: 100%;
        max-width: 480px;
      }
    }
    .poster-color-input {
      width: 36px;
      height: 28px;
      padding: 2px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      cursor: pointer;
      vertical-align: middle;
      background: #fff;
    }
  }
  .poster-wrap {
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background: #e8e8e8;
    padding: 10px 8px;
  }
  .poster-viewport {
    position: relative;
    flex-shrink: 0;
    margin: 0 auto;
  }
  .poster-scale-inner {
    position: absolute;
    left: 0;
    top: 0;
  }
  .poster-canvas-box {
    position: relative;
    flex-shrink: 0;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    .poster-bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: fill;
      display: block;
      pointer-events: none;
    }
    .poster-item {
      position: absolute;
      cursor: move;
      user-select: none;
      pointer-events: auto;
      box-sizing: border-box;
    }
    .poster-avatar {
      overflow: hidden;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
      .avatar-img {
        width: 100%;
        height: 100%;
        border-radius: 12px;
        display: block;
      }
    }
    .poster-text {
      color: #333;
      font-weight: 500;
      line-height: 1.4;
      word-break: break-all;
    }
    .poster-content-text {
      color: #333;
    }
    .poster-item.selected {
      outline: 2px solid #409eff;
      outline-offset: 2px;
      z-index: 10;
    }
  }
}
</style>
